import { HomeHeader, PageHeader } from "../cmsPage.state"
import { linkWrapper } from "../utils/link"
import { DP } from "./blockDefinitions"
import { donationHeaderSrc, donationHeaderSrcSet, homeHeaderSrc, homeHeaderSrcSet, linkGridSrc, linkGridSrcSet, pageheaderLargeSrc, pageheaderLargeSrcDesktop, pageheaderLargeSrcSet, pageheaderLargeSrcSetDesktop, pageheaderLargeSrcSetTablet, pageheaderLargeSrcTablet, pageheaderSmallSrc, pageheaderSmallSrcSet } from "./utils/imageSizes"
import { parseDrupalImageUrls } from "./utils/modernImage"

export const getPageHeader = (json: any): PageHeader => {
  let headerTitle = json.title[0]?.value ?? undefined
  let headerIntroduction = json.field_introduction[0]?.value ?? undefined
  const isDonationPage = json.type?.[0]?.target_id === "donatie_pagina"
  let hideDonationButton =
    isDonationPage
    || json.field_hide_dotation_button && json.field_hide_dotation_button[0] && json.field_hide_dotation_button[0].value
  let hideHeader = json.field_hide_header && json.field_hide_header[0] && json.field_hide_header[0].value === true

  let headerPrimaryLink = json.field_links?.[0]
  let headerSecondaryLink = json.field_links?.[1]

  let headerPublishDate = json.field_publish_date ? new Date(json.field_publish_date[0]?.value) : undefined

  const fieldMediaImage = json.field_introduction_image?.[0]?.target?.field_media_image[0]
  const headerImageSize = json.field_introduction_imagesiz ? json.field_introduction_imagesiz?.[0]?.value == true ? 'large' : 'small' : 'small'
  const headerImage = fieldMediaImage
    ? parseDrupalImageUrls(
        fieldMediaImage,
        undefined,
        isDonationPage
          ? donationHeaderSrcSet
          : headerImageSize == 'small' ? pageheaderSmallSrcSet : pageheaderLargeSrcSet,
        isDonationPage
          ? donationHeaderSrc
          : headerImageSize == 'small' ? pageheaderSmallSrc : pageheaderLargeSrc
      )?.image
    : undefined
  const headerImageTablet = fieldMediaImage
    ? parseDrupalImageUrls(
        fieldMediaImage,
        undefined,
        pageheaderLargeSrcSetTablet,
        pageheaderLargeSrcTablet
      )?.image
    : undefined
  const headerImageDesktop = fieldMediaImage
    ? parseDrupalImageUrls(
        fieldMediaImage,
        undefined,
        pageheaderLargeSrcSetDesktop,
        pageheaderLargeSrcDesktop
      )?.image
    : undefined

  const linkPrimary =
    headerPrimaryLink &&
      headerPrimaryLink.processed_url &&
      headerPrimaryLink.title
      ? linkWrapper({
        url: headerPrimaryLink.processed_url,
        title: headerPrimaryLink.title,
        anchor: headerPrimaryLink.options?.attributes?.id
      }) : undefined

  const linkSecondary =
    headerSecondaryLink &&
      headerSecondaryLink.processed_url &&
      headerSecondaryLink.title
      ? linkWrapper({
        url: headerSecondaryLink.processed_url,
        title: headerSecondaryLink.title,
        anchor: headerSecondaryLink.options?.attributes?.id
      }) : undefined

  return {
    kind: 'normal',
    pageTitle: headerTitle,
    pageIntro: headerIntroduction,
    hideDonationButton: hideDonationButton,
    hideHeader: hideHeader,
    linkPrimary: linkPrimary,
    linkSecondary: linkSecondary,
    image: headerImage,
    imageSize: headerImageSize,
    imageSource: headerImageSize == 'small' ? undefined : headerImageTablet && headerImageDesktop ? [
      {
          imageProportions: {
              width: '1920',
              height: '500',
              sizes: '100vw',
              media: '(min-width: 1280px)',
          },
          image: headerImageDesktop
      },
      {
        imageProportions: {
            width: '1280',
            height: '500',
            sizes: '100vw',
            media: '(min-width: 640px)',
        },
        image: headerImageTablet
      }
    ] : [],
    publishDate: headerPublishDate
  }
}

export const getHomeHeader = (json: any): HomeHeader => {
  let headerTitle = json[0].title[0]?.value ?? undefined
  let headerIntroduction = json[0].field_introduction?.[0]?.value ?? undefined
  let headerPrimaryLink = json[0].field_links?.[0]
  let headerSecondaryLink = json[0].field_links?.[1]

  const fieldMediaImage = json[0].field_introduction_image?.[0]?.target?.field_media_image[0]
  const headerImage = fieldMediaImage ? parseDrupalImageUrls(fieldMediaImage, undefined, homeHeaderSrcSet, homeHeaderSrc)?.image : undefined

  const linkPrimary =
    headerPrimaryLink &&
      headerPrimaryLink.processed_url &&
      headerPrimaryLink.title
      ? linkWrapper({
        url: headerPrimaryLink.processed_url,
        title: headerPrimaryLink.title,
        anchor: headerPrimaryLink.options?.attributes?.id
      }) : undefined

  const linkSecondary =
    headerSecondaryLink &&
      headerSecondaryLink.processed_url &&
      headerSecondaryLink.title
      ? linkWrapper({
        url: headerSecondaryLink.processed_url,
        title: headerSecondaryLink.title,
        anchor: headerSecondaryLink.options?.attributes?.id
      }) : undefined
  
  const headerGrid = json[0].field_homepage_grid
    ? json[0].field_homepage_grid.map((block: DP.GridImage["target"]["field_grid_blocks"][0], key: number) => {
      const blockData = block.target;

      const fieldMediaImage = blockData.field_image[0].target.field_media_image[0]
      const fieldMediaSource = blockData.field_image[0]?.target.field_source[0]
        ? blockData.field_image[0]?.target.field_source
        : undefined
      const dpImages = fieldMediaImage
        ? parseDrupalImageUrls(fieldMediaImage, fieldMediaSource, linkGridSrcSet, linkGridSrc)?.image
        : undefined

      return {
        kind: 'link',
        label: blockData.field_label[0]?.value,
        title: blockData.field_title[0]?.value,
        intro: blockData.field_introduction[0]?.value,
        link: linkWrapper({ title: blockData.field_link[0]?.title, url: blockData.field_link[0]?.processed_url, anchor: blockData.field_link[0]?.options?.attributes?.id }),
        image: dpImages
      }
    })
    : undefined

  return {
    kind: 'home',
    pageTitle: headerTitle,
    pageIntro: headerIntroduction,
    linkPrimary: linkPrimary,
    linkSecondary: linkSecondary,
    image: headerImage,
    hideDonationButton: false,
    hideHeader: false,
    grid: headerGrid
  }
}
